import $ from 'jquery'
import 'owl.carousel'
import 'magnific-popup'
import LazyLoad from 'vanilla-lazyload'

import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm'
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm'

// height windows for ios
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

// header
(function () {
    const header = $('.header:not(.inpage)'),
        burger = $('.header__burger'),
        wrapper = header.find('.header__wrapper'),
        items = header.find('.header__item');

    items.each(function () {
        let item = $(this),
            head = item.find('.header__head'),
            body = item.find('.header__body');

        head.on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (!item.hasClass('active')) {
                header.addClass('toggle');
                items.removeClass('active');
                item.addClass('active');
            } else {
                header.removeClass('toggle');
                items.removeClass('active');
            }
        });

    });

    burger.on('click', function (e) {
        e.stopPropagation();
        burger.toggleClass('active');
        wrapper.toggleClass('visible');
    });

    wrapper.on('click', function (e) {
        e.stopPropagation();
    });

    // last minute make mobile nav work for inPage nav... TODO merge this with above
    const headerInpage = $('.header.inpage'),
        burgerInPage = $('.header__burger'),
        wrapperInPage = headerInpage.find('.header__wrapper'),
        itemsInPage = headerInpage.find('.header__item');

    itemsInPage.each(function () {
        let item = $(this),
            head = item.find('.header__head'),
            body = item.find('.header__body');

        head.on('click', function (e) {
            burgerInPage.removeClass('active');
            wrapperInPage.removeClass('visible');
        });

    });

    burgerInPage.on('click', function (e) {
        e.stopPropagation();
        burgerInPage.toggleClass('active');
        wrapperInPage.toggleClass('visible');
    });

    wrapperInPage.on('click', function (e) {
    });

    $('html, body').on('click', function () {
        burger.removeClass('active');
        wrapper.removeClass('visible');
        header.removeClass('toggle');
        items.removeClass('active');
        burgerInPage.removeClass('active');
        wrapperInPage.removeClass('visible');
    });

}());

// faq
(function () {
    const faq = $('.faq'),
        items = faq.find('.faq__item');

    items.each(function () {
        let item = $(this),
            head = item.find('.faq__head'),
            body = item.find('.faq__body');

        head.on('click', function (e) {
            item.toggleClass('active');
            body.slideToggle();
        });

    });

}());

// testimonial slider
(function () {
    const slider = $('.testimonial__slider'),
        next = $('.testimonial__next'),
        numberValue = $('.testimonial__counter');

    slider.owlCarousel({
        items: 1,
        dots: false,
        smartSpeed: 700,
        loop: true,
        autoHeight: true,
        onInitialized: counter,
        onTranslated: counter
    });


    next.click(function () {
        slider.trigger('next.owl.carousel');
    })

    function counter(event) {
        let element = event.target,
            items = event.item.count,
            item = event.item.index + 1;

        if (item > items) {
            item = item - items;
        };

        numberValue.html(item + " / " + items);
    };

})();

// gallery slider
(function () {
    const slider = $('.gallery__slider'),
        prev = $('.gallery__prev'),
        next = $('.gallery__next'),
        numberValue = $('.gallery__counter');

    slider.owlCarousel({
        items: 1,
        dots: false,
        smartSpeed: 700,
        // autoHeight: true,
        onInitialized: counter,
        onTranslated: counter
    });


    next.click(function () {
        slider.trigger('next.owl.carousel');
    });

    prev.click(function () {
        slider.trigger('prev.owl.carousel');
    });

    function counter(event) {
        let element = event.target,
            items = event.item.count,
            item = event.item.index + 1;

        if (item > items) {
            item = item - items;
        };

        numberValue.html(item + " / " + items);
    };

})();

// main slider
(function () {
    const slider = $('.main__slider');

    slider.owlCarousel({
        items: 1,
        dots: true,
        smartSpeed: 1500,
        mouseDrag: false,
        touchDrag: false,
        loop: true,
        animateOut: "fadeOut",
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: false,
    });
})();

// tabs
(function () {
    var tabs = $('.details');
    tabs.each(function () {
        var thisTabs = $(this),
            nav = thisTabs.find('.details__nav a'),
            item = thisTabs.find('.details__item');
        nav.on('click', function () {
            var thisNav = $(this),
                indexNav = thisNav.parents('li').index();
            nav.removeClass('active');
            thisNav.addClass('active');
            item.hide();
            item.eq(indexNav).fadeIn();
            return false;
        });
    });
})();


//popup gallery
document.querySelectorAll('.popupgallery').forEach(function (i) {
    const lightbox = new PhotoSwipeLightbox({
        gallery: i,
        children: '.pswp-item',
        pswpModule: PhotoSwipe,
        tapAction: 'zoom',
        bgOpacity: 0.95,
        showHideAnimationType: 'none',
        zoomAnimationDuration: false,
        showAnimationDuration: 0,
        hideAnimationDuration: 0,
    })
    lightbox.addFilter('useContentPlaceholder',
        (useContentPlaceholder, content) => { return false; })
    lightbox.init()
})

window.lazyLoad = new LazyLoad({
    elements_selector: '[data-src], [data-srcset], [data-bg]'
})

$('.main video').each(function () {
    var $elem = $(this)
    //if (window.innerWidth > 768) {
        $elem.attr('preload', 'auto')
        this.autoplay = true
        this.load()
        this.play()
    //}
})

$('.main button.play').click(function () {
    var vid = $('.main video')[0]
    vid.load()
    vid.play()
})

$('.footer-sub input').on('keyup', function () {
    var rx = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    var hp = $('input#cd_ht_text').val()
    var first = $('input[data-field="first"]').val()
    var last = $('input[data-field="last"]').val()
    var email = $('input[data-field="email"]').val()
    if (hp.length == 0 && first.length >= 2 && last.length >= 2 && email.length >= 2 && rx.test(email)) {
        $('.footer-sub #btnSubmit').removeAttr('disabled')
    } else {
        $('.footer-sub #btnSubmit').attr('disabled', '')
    }
})